import { render, staticRenderFns } from "./usertext.vue?vue&type=template&id=a6252e4e&scoped=true&"
import script from "./usertext.vue?vue&type=script&lang=js&"
export * from "./usertext.vue?vue&type=script&lang=js&"
import style0 from "./usertext.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./usertext.vue?vue&type=style&index=1&id=a6252e4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6252e4e",
  null
  
)

export default component.exports